import React, { Component } from "react";
import { Row, Col, Form, Modal, Button, Spinner } from "react-bootstrap";

class ModalEdit extends Component {
  state = {};
  render() {
    return (
      <Modal
        show={this.props.showEditModal}
        onHide={this.props.handleClose}
        dialogClassName="editModal"
      >
        <Form onSubmit={this.props.onFormSubmitEditUser}>
          <Modal.Header closeButton>
            <h3>Edit User</h3>
          </Modal.Header>
          <Modal.Body>
            <div style={{ fontSize: "13px", fontWeight: "500" }}>
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={this.props.teams !== false && this.props.teams.length >= 1 ? 4 : 6}>
                      <Form.Group controlId="formFirstName">
                        <Form.Label>First Name *</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.first_name : ""
                          }
                          name="firstName"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={this.props.teams !== false && this.props.teams.length >= 1 ? 4 : 6}>
                      <Form.Group controlId="formLastName">
                        <Form.Label>Last Name *</Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.last_name : ""
                          }
                          name="lastName"
                        />
                      </Form.Group>
                    </Col>
                    {this.props.teams !== false && this.props.teams.length >= 1 && (
                      <Col md={4}>
                        <Form.Group controlId="formTeamId">
                          <Form.Label>Team</Form.Label>
                          <Form.Control
                            as="select"
                            defaultValue={
                              this.props.editUser !== null ? this.props.editUser.team_id : 1
                            }
                            name="teamId"
                          >
                            {this.props.teams.map((triggerBatch) => {
                              return (
                                <option value={triggerBatch.id}>{triggerBatch.team_name}</option>
                              );
                            })}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    )}
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group controlId="formTriggerBatch">
                        <Form.Label>Trigger Batch</Form.Label>
                        <Form.Control
                          as="select"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.trigger_batch : 1
                          }
                          name="triggerBatch"
                        >
                          {this.props.triggerBatches.map((triggerBatch) => {
                            return <option value={triggerBatch.id}>{triggerBatch.name}</option>;
                          })}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formEmail">
                        <Form.Label>Email Address *</Form.Label>
                        <Form.Control
                          required
                          type="email"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.user_email : ""
                          }
                          name="emailAddress"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group controlId="formPassword">
                        <Form.Label>Password *</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.user_password : ""
                          }
                          name="password"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group controlId="formPerPoundShipment">
                        <Form.Label>Per Pount Shipment Rate</Form.Label>
                        <Form.Control
                          type="number"
                          step="0.01"
                          placeholder="0.3"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.per_pound : ""
                          }
                          name="perPound"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formMWSSeller">
                        <Form.Label>MWS Seller ID</Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.mws_seller_id : ""
                          }
                          name="mwsSellerId"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formMWSAuth">
                        <Form.Label>MWS Auth</Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.mws_auth_token : ""
                          }
                          name="mwsAuthToken"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group controlId="formTeamId">
                        <Form.Label>Shipping Rate Plan</Form.Label>
                        <Form.Control
                          as="select"
                          defaultValue={
                            this.props.editUser !== null &&
                            this.props.editUser.shipping_rate_plan !== ""
                              ? this.props.editUser.shipping_rate_plan
                              : 1
                          }
                          name="shippingPlanId"
                        >
                          <option value={0}>Choose One</option>
                          {this.props.shippingPlans.map((shippingPlan) => {
                            return (
                              <option value={shippingPlan.id}>{shippingPlan.plan_name}</option>
                            );
                          })}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formRMSToken">
                        <Form.Label>RMS API Token</Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.rms_api_key : ""
                          }
                          name="rmsApiToken"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formSBYBEmail">
                        <Form.Label>SBYB Email</Form.Label>
                        <Form.Control
                          type="email"
                          defaultValue={
                            this.props.editUser !== null ? this.props.editUser.sbyb_email : ""
                          }
                          name="sbybEmailAddress"
                        />
                      </Form.Group>
                    </Col>
                    {/* <Col md={3}>
                      <Form.Group controlId="formBRAPIKey">
                        <Form.Label>BR API Key</Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={
                            this.props.editUser !== null
                              ? this.props.editUser.key_br
                              : "48cfkr7iasgdx7ds82s6"
                          }
                          name="brApiKey"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formSBAPIKey">
                        <Form.Label>SB API Key</Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={
                            this.props.editUser !== null
                              ? this.props.editUser.key_sb
                              : "3c7ce4aa84a0418cdd4e8560f0af5026"
                          }
                          name="sbApiKey"
                        />
                      </Form.Group>
                    </Col> */}
                  </Row>

                  <Row style={{ marginTop: "20px" }}>
                    <Col md={3}>
                      <Form.Check
                        defaultChecked={
                          this.props.editUser !== null ? this.props.editUser.is_active : false
                        }
                        type="switch"
                        name="isActive"
                        id="is-active"
                        label="Active?"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Check
                        defaultChecked={
                          this.props.editUser !== null ? this.props.editUser.hidden_mode : false
                        }
                        type="switch"
                        name="isHiddenMode"
                        id="is-hidden"
                        label="Hidden Mode?"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Check
                        defaultChecked={
                          this.props.editUser !== null ? this.props.editUser.show_sales_rank : false
                        }
                        type="switch"
                        name="isSalesRank"
                        id="is-show-rank"
                        label="Show Rank?"
                      />
                    </Col>
                    <Col md={3}>
                      <Form.Check
                        defaultChecked={
                          this.props.editUser !== null
                            ? this.props.editUser.infoboxes_enabled
                            : false
                        }
                        type="switch"
                        name="isInfoBoxes"
                        id="is-info-boxes"
                        label="InfoBoxes?"
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.props.inProgressEdit === true ? (
              <Spinner animation="border" role="status"></Spinner>
            ) : (
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default ModalEdit;
